export default __webpack_public_path__ + "static/airbnb-df408fc61cb51786e5cecb1d078ac950.svg";